import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PreviousRouteService {

  private previousUrl: string;
  private previousNotAuthUrl: string;
  private currentUrl: string;

  constructor(private router: Router) {
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {        
        this.previousUrl = this.currentUrl;
        
        if ( -1 === this.currentUrl.indexOf('/auth/') ) {
          this.previousNotAuthUrl = this.currentUrl;
        }

        this.currentUrl = event.url;
      };
    });
  }

  public getPreviousUrl() {
    return this.previousUrl;
  }   

  public getPreviousNotAuthUrl() {
    return this.previousNotAuthUrl;
  }    
}